export const CONTEST_LIST_REQUEST = 'CONTEST_LIST_REQUEST'
export const CONTEST_LIST_SUCCESS = 'CONTEST_LIST_SUCCESS'
export const CONTEST_LIST_FAIL    = 'CONTEST_LIST_FAIL'

export const CONTEST_DETAILS_REQUEST = 'CONTEST_DETAILS_REQUEST'
export const CONTEST_DETAILS_SUCCESS = 'CONTEST_DETAILS_SUCCESS'
export const CONTEST_DETAILS_FAIL    = 'CONTEST_DETAILS_FAIL'
export const CONTEST_DETAILS_RESET   = 'CONTEST_DETAILS_RESET'

export const CONTEST_CREATE_REQUEST = 'CONTEST_CREATE_REQUEST'
export const CONTEST_CREATE_SUCCESS = 'CONTEST_CREATE_SUCCESS'
export const CONTEST_CREATE_FAIL    = 'CONTEST_CREATE_FAIL'
export const CONTEST_CREATE_RESET   = 'CONTEST_CREATE_RESET'

export const CONTEST_UPDATE_REQUEST = 'CONTEST_UPDATE_REQUEST'
export const CONTEST_UPDATE_SUCCESS = 'CONTEST_UPDATE_SUCCESS'
export const CONTEST_UPDATE_FAIL    = 'CONTEST_UPDATE_FAIL'
export const CONTEST_UPDATE_RESET   = 'CONTEST_UPDATE_RESET'

export const CONTEST_DELETE_REQUEST = 'CONTEST_DELETE_REQUEST'
export const CONTEST_DELETE_SUCCESS = 'CONTEST_DELETE_SUCCESS'
export const CONTEST_DELETE_FAIL    = 'CONTEST_DELETE_FAIL'
